// extracted by mini-css-extract-plugin
module.exports = {"EventsGrid":"EventsGrid_EventsGrid__3cE52","Cell":"EventsGrid_Cell__2m11H"};